import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useAuth, consumeLoginRedirect } from "./providers/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { currentUser, authChecked } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // The dev login redirects to "/" rather than /login, so LoginForm never
  // sees it — pick up any page stashed before the SAML round trip here too.
  useEffect(() => {
    if (!currentUser) return;
    const redirectTo = consumeLoginRedirect();
    if (redirectTo && redirectTo !== location.pathname + location.search) {
      navigate(redirectTo, { replace: true });
    }
    // Only on sign-in, not on every navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?._id]);

  // Still waiting on the initial check-auth — don't bounce a deep link to
  // /login before we know whether the session is valid.
  if (!authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!currentUser) {
    // Redirect them to the login page, but save the current location they were trying to go to
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
